<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="top-login pt-3">
          <v-img
            :max-height="source.startsWith('store') ? 70 : 60"
            contain
            :src="logoName"
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters align="center">
      <v-col cols="12" sm="8" md="6" class="pa-0 text-center">
        <div class="login-part">
          <v-row justify="center">
            <v-col cols="12" md="8">
              <v-card
                flat
                :loading="loading"
                :disabled="loading"
                color="#F8F9FA"
                max-width="620"
                min-height="50vh"
              >
                <v-card-text>
                  <div v-if="source.startsWith('store')" class="form-size">
                    <span
                      v-if="source === 'store-admin'"
                      class="text-h4 text-md-h3 text-lg-h2 primary--text font-weight-medium"
                      >Gerenciador
                    </span>
                    <span
                      v-else
                      class="text-h4 text-md-h3 text-lg-h2 primary--text font-weight-medium"
                      >Bem-vindo à
                    </span>
                    <br />
                    <span
                      class="text-h4 text-md-h3 text-lg-h2 secondary--text font-weight-bold"
                      >Agrinvest Store</span
                    >
                  </div>
                  <div v-else class="form-size">
                    <div
                      class="text-h4 text-md-h3 text-lg-h2 primary--text font-weight-medium"
                    >
                      Bem-vindo ao
                    </div>
                    <div
                      class="text-h4 text-md-h3 text-lg-h2 secondary--text font-weight-bold"
                    >
                      Pro Market
                    </div>
                  </div>
                  <v-form>
                    <v-text-field
                      label="E-mail"
                      color="#d1ae6c"
                      name="login"
                      prepend-icon="mdi-at"
                      type="text"
                      v-model="email"
                      autocomplete="username"
                    />

                    <v-text-field
                      id="password"
                      label="Senha"
                      color="#d1ae6c"
                      name="password"
                      prepend-icon="mdi-key"
                      type="password"
                      v-model="password"
                      @keydown.enter="loginUser"
                      autocomplete="current-password"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="#04524e"
                    :loading="loading"
                    outlined
                    block
                    rounded
                    @click="loginUser"
                    >Entrar</v-btn
                  >
                </v-card-actions>
                <template slot="progress">
                  <v-progress-linear
                    color="#04524e"
                    indeterminate
                  ></v-progress-linear>
                </template>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="0" sm="4" md="6" class="d-none d-sm-flex">
        <v-img min-height="100vh" src="../assets/agrinvest-bg.png" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginService from "@/services/login";
import AuthService from "@/services/auth";

export default {
  name: "LoginPage",
  data: () => ({
    email: undefined,
    password: undefined,
    loading: false,
  }),

  computed: {
    source() {
      if (!this.$route.query.source) return "promarket";
      return this.$route.query.source;
    },
    redirect_url() {
      if (this.$route.query.redirect_url) return this.$route.query.redirect_url;
      return undefined;
    },
    serviceCallback() {
      if (this.source === "store") return process.env.VUE_APP_STORE_CALLBACK;
      else if (this.source === "store-admin")
        return process.env.VUE_APP_STORE_ADMIN_CALLBACK;
      else return process.env.VUE_APP_INTEL_CALLBACK;
    },
    logoName() {
      if(this.source.startsWith('store'))
        return require('../../public/img/agrinvest-logo.png');
      else
        return require('../../public/img/logo.png');
    }
  },

  methods: {
    async loginUser() {
      const credencials = {
        email: this.email,
        password: this.password,
      };
      this.loading = true;
      try {
        await LoginService.update_user_bitzen(credencials);
        const response = await LoginService.signin(credencials);
        const token = response.data.token;
        AuthService.setToken(token);
        this.loading = false;
        // Add params to URL
        let service_url = `${this.serviceCallback}?token=${token}`;
        if(this.redirect_url) {
          service_url = `${service_url}&redirect_url=${this.redirect_url}`;
        }
        // Redict to the service
        window.location = service_url;
      } catch (error) {
        this.loading = false;
        if (error?.response?.status == 401) {
          this.$alertError("Não foi possível autenticar o usuário");
          this.$alertError("Verifique o seu usuário e/ou senha.");
        } else {
          this.$alertError(
            "Ocorrer um problema ao autenticar, tente mais tarde."
          );
          console.error(error);
        }
      }
    },
  },
};
</script>

<style lang="sass">
.top-login
    min-height: 100px
    background-color: #ffffff

.login-part
    min-height: 100vh
    background-color: #F8F9FA
    display: flex
    justify-content: center
    align-items: center

.form-size
    min-height: 100px

.space
    min-height: 20vh

$toast-font-size: 18px

.container-toast-class
  top: 1% !important
  left: 5% !important

.toast-class
  font-family: 'roboto' !important
  font-size: 14px !important
  font-weight: 600 !important
  background-color: #000000 !important

  .action
    font-size: 14px !important
    font-weight: 600 !important
    color: #d1ae6c !important
    text-decoration: none !important
    padding: 4px

    &:hover
      background-color: #04524e !important

.error-toast-class
  font-family: 'roboto' !important
  font-size: $toast-font-size !important
  font-weight: 600 !important
  background-color: #EF5052 !important

  .action
    font-size: 14px !important
    font-weight: 600 !important
    color: #fff !important
    text-decoration: none !important
    padding: 4px

    &:hover
      background-color: #525252 !important

.success-toast-class
  font-family: 'roboto' !important
  font-size: $toast-font-size !important
  font-weight: 600 !important
  background-color: #7CB342 !important

  .action
    font-size: 14px !important
    font-weight: 600 !important
    color: #fff !important
    text-decoration: none !important
    padding: 4px

    &:hover
      background-color: #373E40 !important

.info-toast-class
  font-family: 'roboto' !important
  font-size: $toast-font-size !important
  font-weight: 600 !important
  background-color: #1E88E5 !important

  .action
    font-size: 14px !important
    font-weight: 600 !important
    color: #fff !important
    text-decoration: none !important
    padding: 4px

    &:hover
      background-color: #373E40 !important
</style>
